import api, { ProxyMediaArgs } from '@sparemin/api-sdk';
import qs from 'query-string';
import { SuperAgentStatic } from 'superagent';
import { SPAREMIN_SERVICES_AUDIO_PROXY_URL } from 'config';
import { createRequest } from '../utils';
import {
  ExternalMediaExistsArgs,
  ExternalMediaExistsResult,
  ProxyMediaResult,
  ServiceMethod,
} from './types';

async function getProxyMediaEndpoint(
  args: ProxyMediaArgs,
): Promise<ProxyMediaResult> {
  return api.getProxyMediaEndpoint(args);
}

async function externalMediaExists(
  request: SuperAgentStatic,
  [url]: ExternalMediaExistsArgs,
): Promise<ExternalMediaExistsResult> {
  const res = await request.head('/audio-proxy').query({
    url: qs.stringifyUrl({
      url,
      query: {
        // https://serverfault.com/questions/856904/chrome-s3-cloudfront-no-access-control-allow-origin-header-on-initial-xhr-req/856948#856948
        'x-request': 'xhr',
      },
    }),
  });

  return res.ok;
}

export function handle(method: any, args: any) {
  const request = createRequest({
    baseUrl: SPAREMIN_SERVICES_AUDIO_PROXY_URL,
  });

  switch (method) {
    case ServiceMethod.EXTERNAL_MEDIA_EXISTS:
      return externalMediaExists(request, args);

    case ServiceMethod.PROXY_MEDIA:
      return getProxyMediaEndpoint(args);
  }

  return undefined;
}
